import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/components/auth/AuthProvider';
import { RequireAuth } from '@/components/auth/RequireAuth';
import Layout from '@/components/Layout';
import LoginPage from '@/pages/auth/LoginPage';
import ForgotPasswordPage from '@/pages/auth/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/auth/ResetPasswordPage';
import Dashboard from '@/pages/Dashboard';
import ReportIssue from '@/pages/ReportIssue';
import TrackIssue from '@/pages/TrackIssue';
import Schools from '@/pages/Schools';
import Regions from '@/pages/Regions';
import SchoolLevels from '@/pages/SchoolLevels';
import Grades from '@/pages/Grades';
import Recipients from '@/pages/Recipients';
import ReportedIssues from '@/pages/ReportedIssues';
import ViewIssue from '@/pages/ViewIssue';
import EditIssue from '@/pages/EditIssue';
import AISummaries from '@/pages/AISummaries';
import Users from '@/pages/Users';

function App() {
  return (
    <>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<ReportIssue />} />
          <Route path="/track-issue" element={<TrackIssue />} />

          {/* Auth routes */}
          <Route path="/auth/login" element={<LoginPage />} />
          <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/auth/reset-password" element={<ResetPasswordPage />} />

          {/* Protected routes */}
          <Route element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }>
            <Route path="/admin" element={<Dashboard />} />
            <Route path="/admin/reported-issues" element={<ReportedIssues />} />
            <Route path="/admin/reported-issues/:id" element={<ViewIssue />} />
            <Route path="/admin/reported-issues/:id/edit" element={<EditIssue />} />
            <Route path="/admin/ai-summaries" element={<AISummaries />} />
            <Route path="/admin/schools" element={<Schools />} />
            <Route path="/admin/regions" element={<Regions />} />
            <Route path="/admin/school-levels" element={<SchoolLevels />} />
            <Route path="/admin/grades" element={<Grades />} />
            <Route path="/admin/recipients" element={<Recipients />} />
            <Route path="/admin/users" element={<Users />} />
          </Route>
        </Routes>
      </AuthProvider>
      <Toaster />
    </>
  );
}

export default App;